import clsx from "clsx";

export const TransactionBadge = ({ status }) => {
  return (
    <p
      className={clsx(
        status === "success"
          ? "bg-[#91FED1] text-[#016C2C]"
          : status === "pending"
            ? "bg-[#FADF9F] text-[#C09525]"
            : "bg-[#FDC2C2] text-[#F54B5F]",
        "px-1.5 py-[3px] rounded-[4px] text-[9px] leading-none text-center w-fit float-end",
      )}
    >
      <span> {status}</span>
    </p>
  );
};
